module.exports = __webpack_public_path__ + "static/img/img-mbti-random1.30a5285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-mbti-random1.jpg
// module id = qBN+
// module chunks = 156 157